import { Bike, Clock, Croissant, Flame, Map, Utensils, Wifi, Zap, type LucideIcon } from "lucide-react";
import type { GuestTabletUpsellOffer } from "@/types/guestTablet";

const ICONS: Record<string, LucideIcon> = {
  croissant: Croissant,
  bike: Bike,
  zap: Zap,
  clock: Clock,
  wifi: Wifi,
  flame: Flame,
  map: Map,
  utensils: Utensils,
};

type Props = {
  offers: GuestTabletUpsellOffer[];
};

export function TabletUpselling({ offers }: Props) {
  if (offers.length === 0) return null;

  return (
    <section className="guest-tablet-card p-6 md:p-8">
      <h2 className="guest-tablet-section-title mb-2">Das könnte Sie interessieren</h2>
      <p className="mb-6 text-label-secondary">Dezente Empfehlungen – gerne beraten wir Sie an der Rezeption.</p>
      <div className="grid gap-4 sm:grid-cols-2">
        {offers.map((offer) => {
          const Icon = ICONS[offer.icon] ?? SparklesFallback;
          return (
            <article
              key={offer.id}
              className="rounded-xl border border-emerald-900/8 bg-gradient-to-br from-white/60 to-emerald-900/5 p-4 dark:from-white/5 dark:to-transparent"
            >
              <div className="flex items-start gap-3">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-700 dark:text-emerald-300" />
                <div>
                  <h3 className="font-semibold">{offer.title}</h3>
                  <p className="mt-1 text-base leading-relaxed text-label-secondary">{offer.description}</p>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

function SparklesFallback({ className }: { className?: string }) {
  return <span className={className}>✦</span>;
}
